export default (pre, url) => `${pre}/${url}`;